import * as React from 'react';

import type {DashboardStatsFragment as Stat} from 'nutshell-graphql-types';

import {Card} from '../../card/card';
import {LoadingPage} from '../../loading-page/loading-page';
import {Body} from '../../typography/body';

import {DashboardCardMainContent} from './dashboard-card-main-content';
import {DashboardCardSideContent} from './dashboard-card-side-content';

import styles from './dashboard-card.module.css';

type Props = {
    title: string;
    subtitle: string;
    link?: React.ReactNode;
    isLoading?: boolean;
    mainContent: {
        statsProps?: {
            stats: Stat[];
            isHorizontal?: boolean;
        };
        content: React.ReactNode;
    };
    sideContentProps?: {
        content: React.ReactNode;
        isFullHeight?: boolean;
    };
    promoStateOverlay?: React.ReactNode;
};

export function DashboardCard(props: Props) {
    const sideContent = props.sideContentProps && props.sideContentProps.content;
    const sideContentIsFullHeight = props.sideContentProps && props.sideContentProps.isFullHeight;

    return (
        <Card hasBorder={true} fitHeight={true}>
            <div className={styles.container}>
                <div className='flex flex-dir-col full-width full-height'>
                    <div className='flex justify-sb px-16 py-8 border-bottom align-center gap-16'>
                        <div className='flex flex-dir-col'>
                            <Body isBold={true}>{props.title}</Body>
                            <Body color='light' isItalic={true} size='small'>
                                {props.subtitle}
                            </Body>
                        </div>
                        {props.link}
                    </div>
                    {props.isLoading && <LoadingPage />}
                    <div className='flex full-height'>
                        {!props.isLoading && <DashboardCardMainContent {...props.mainContent} />}
                        {sideContent && !sideContentIsFullHeight && !props.isLoading && (
                            <DashboardCardSideContent content={sideContent} />
                        )}
                    </div>
                </div>
                {sideContent && sideContentIsFullHeight && !props.isLoading && (
                    <DashboardCardSideContent content={sideContent} />
                )}
                {props.promoStateOverlay}
            </div>
        </Card>
    );
}
